// PRODUCT-ID-NORMALIZE-001 — mirror of backend services/product_display.normalize_product_id
// Trim, collapse whitespace runs, remove spaces around separators (- _ / . :).
// "409439 - 3" → "409439-3". All other characters are kept verbatim.
export function normalizeProductId(value) {
  if (typeof value !== 'string') return value;
  return value
    .split(/\s+/)
    .filter(Boolean)
    .join(' ')
    .replace(/\s*([-_/.:])\s*/g, '$1')
    .trim();
}
